import notify from 'devextreme/ui/notify';

const POINT_MESSAGE = 'Точка учета не зарегистрирована в ИСУ';
const DOG_MESSAGE = 'Договор не зарегистрирован в ИСУ';

function isNotRegistered(result) {
    const message = result?.message || '';
    return result?.code === 'ISUE_NOT_REGISTERED'
        || message === 'Внутренняя ошибка сервера'
        || message === 'Объект не содержит token'
        || /token not found/i.test(message);
}

export function notifyIsueAuthFail(result, scope) {
    const fallback = scope === 'dog' ? DOG_MESSAGE : POINT_MESSAGE;
    if (isNotRegistered(result)) {
        const message = result?.message;
        const text = result?.code === 'ISUE_NOT_REGISTERED' && message && message !== 'Внутренняя ошибка сервера'
            ? message
            : fallback;
        notify(text, 'warning', 5000);
        return;
    }
    notify(result?.message || fallback, 'error', 3000);
}
